import { atom } from 'jotai';
import { deliveryreceiverSect } from '../constantsBooking';
import { STA_COMPANY_ID } from '../../../helper/companyIdhardcode';

export const showListAtom = atom(false)
export const showDropAtom = atom(false)
export const activeDropAtom = atom(false)
export const deliveryLuggageAtom = atom(null)
export const selectIdAtom = atom(null)
export const selectLrNumberAtom = atom(null)
export const inputLRNumberAtom = atom(null)

export const filteredDeliveryListAtom = atom([]);
export const receiverFlagsDelAtom = atom({
  RemoveReceiverGSTIN: 0,
  IsRemoveReceiverOtherInfo: 0,
  RemoveHomeDelivery: 0,
  DefaultCurrencyID: 0,
  intCompanyID: 0,
  RemoveReceiverID: 0,
})

export const updatedReceiverDelSectAtom = atom((get) => {
  const tabs = [...deliveryreceiverSect]
  const { RemoveReceiverGSTIN, IsRemoveReceiverOtherInfo, RemoveHomeDelivery, DefaultCurrencyID, intCompanyID, RemoveReceiverID } =
    get(receiverFlagsDelAtom)

  return tabs.filter((tab) => {
    if (tab.id === 0 && (RemoveReceiverGSTIN === 1 || DefaultCurrencyID === 2)) return false
    if (tab.id === 1 && (IsRemoveReceiverOtherInfo === 1 || DefaultCurrencyID === 2)) return false
    if (tab.id === 2 && (RemoveHomeDelivery === 1 || intCompanyID === STA_COMPANY_ID)) return false
    if (tab.id === 3 && RemoveReceiverID === 1) return false
    return true
  })
})
export const deliveryDataAtom = atom({})
export const deliveryIdFileAtom = atom('')
export const deliveryRecImageFileAtom = atom('')
